import { IApiResponse } from './iapi-response';
import { IVendor } from './ivendor';
//used for vendor search results
export interface IVendorSearchResponse extends IVendor, IApiResponse {
  uniqueCommercialVendorReference: string;
  uniqueGroupReportingVendorReference: string;
}
